import { createRoot } from 'react-dom/client';
import { Root } from './components/root';
import React from 'react';
createRoot(document.getElementById('ulabel')!).render(<Root />);